import { semantic, neutral, secondary } from '../../../theme/colors';
import shadows from '../../../theme/shadows';
import typography from '../../../theme/typography';
export const Primary = {
    colors: {
        main: '#00B2E3',
        mainDark: '#0087C1',
        mainLight: '#CBF6FF',
        ...semantic,
        ...neutral,
        ...secondary,
        //
        black_1: '#2E2F33',
        black_2: '#2E2F33',
        black_3: '#2E2F33',
        //
        blackDark_1: '#111113',
        blackDark_2: '#111113',
        blackDark_3: '#111113',
        //
        grey00_1: '#FFFFFF',
        grey00_2: '#FFFFFF',
        grey00_3: '#FFFFFF',
        grey00_4: '#FFFFFF',
        grey00_5: '#FFFFFF',
        grey00_6: '#FFFFFF',
        grey00_7: '#FFFFFF',
        //
        grey01_1: '#F7F7F8',
        grey01_2: '#F7F7F8',
        grey01_3: '#F7F7F8',
        //
        grey05_1: '#F2F2F3',
        grey05_2: '#F2F2F3',
        grey05_3: '#F2F2F3',
        grey05_4: '#F2F2F3',
        //
        grey10_1: '#EAEBEB',
        grey10_2: '#EAEBEB',
        grey10_3: '#EAEBEB',
        grey10_4: '#EAEBEB',
        grey10_5: '#EAEBEB',
        grey10_6: '#efefef',
        //
        grey30_1: '#D7D8DA',
        grey30_2: '#D7D8DA',
        grey30_3: '#D7D8DA',
        //
        grey70_1: '#A1A2A8',
        grey70_2: '#A1A2A8',
        grey70_3: '#A1A2A8',
        //
        grey100_1: '#6D7176',
        grey100_2: '#6D7176',
        //
        positive120_1: '#056B42',
        positive120_2: '#056B42',
        //
        positive30_1: '#74E6AD',
        positive30_2: '#74E6AD',
        //
        positive10_1: '#E8FCF1',
        positive10_2: '#E8FCF1',
        //
        warning120_1: '#A57412',
        warning120_2: '#A57412',
        //
        warning30_1: '#FDDC72',
        warning30_2: '#FDDC72',
        //
        warning10_1: '#FFF2CC',
        warning10_2: '#FFF2CC',
        //
        critical120_1: '#BB2532',
        critical120_2: '#BB2532',
        //
        critical30_1: '#FF8993',
        critical30_2: '#FF8993',
        //
        critical10_1: '#FFD1DA',
        critical10_2: '#FFD1DA',
        critical10_3: '#FFD1DA',
        //
        link120_1: '#104D93',
        link120_2: '#104D93',
        //
        link100: '#1268ED',
        //
        link70: '#4C8AF6',
        //
        link30_1: '#B1CFFB',
        link30_2: '#B1CFFB',
        //
        link10_1: '#E7EEFE',
        link10_2: '#E7EEFE',
    },
    shadows: {
        ...shadows,
    },
    typography,
    borders: {
        radiusMedium: 8,
    },
    themeId: 'primary',
};
